import React from 'react'

export default function Home() {
  return (
    <>
      <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '70vh' }}>
        <h1>สวัสดี</h1>
      </div>
    </>
  )
}
